import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Product } from '@shared/models/product.model';

@Component({
  selector: 'app-price-mode-sidebar',
  templateUrl: './price-mode-sidebar.component.html',
  styleUrls: ['./price-mode-sidebar.component.scss'],
})
export class PriceModeSidebarComponent {
  @Output() productDetailsClick = new EventEmitter<void>();
  @Output() closeSidebar = new EventEmitter<void>();
  @Input() isMobile = false;

  targetCasePriceSet = false;

  // NOTE FOR IMPLEMENTATION:
  // 1) Make sure you add pipes where they are needed in the html file
  // 2) Remove the mock data below
  // 3) Change variable names appropriately
  // REMOVE ME - IM JUST MOCK DATA
  @Input() product: Product = {
    productNumber: 3001,
    summary: {
      productNumber: 3001,
      addDate: '1994-03-20T00:00:00Z',
      breakable: false,
      catchWeightFlag: false,
      contractExcepProdNumber: null,
      classDescription: 'Dry Food',
      divisionNumber: 2099,
      brand: 'Mock Brand',
      brandID: '7009',
      brandType: '2',
      isExclusiveBrand: true,
      eachUom: 'EA',
      grossWeight: 24.8,
      lastMaintenanceDate: '1994-03-20T00:00:00Z',
      lastUpdateDate: '1994-03-20T00:00:00Z',
      locallySourceIndicator: false,
      locallySourcedCity: null,
      locallySourcedDistance: 0,
      locallySourcedNote: null,
      locallySourcedProducer: null,
      locallySourcedState: '',
      locallySourcedZip: 0,
      locallySrcMaintDate: null,
      netWeight: 22,
      priceUom: 'CS',
      productDescLong: 'ICING, VNL CRM RTU SHLF STABL',
      productDescTxtl: 'ICING, VANILLA CREAM RTU SHELF STABLE ALLERGEN',
      productStorageCode: 10,
      proprietaryInd: 'N',
      properties: new Set(),
      replacementConvFactor: 0,
      replacementProductNumber: 12345,
      salesPackSize: '2/11 LB',
      salesUom: 'CS',
      statusChangeDate: '1994-03-20T00:00:00Z',
      storageDescription: null,
      standardComparisonUOM: null,
      standardComparisonValue: null,
      classCode: '100',
      groupCode: '200',
      groupDescription: 'Dry Food Group',
      categoryCode: '300',
      categoryDescription: 'Dry Food Category',
      groupStorageCode: '400',
      groupStorageCodeDescription: 'Dry Storage',
      poDates: [],
      cashCarryIndicator: '0',
      productStatus: 'A',
      purchaseFromVendor: 547,
      vendorEffectiveDate: null,
      vendorActiveInd: null,
      vendorLeadTime: null,
      vendorMessage: '',
      vendorMessageLastUpdateDTM: null,
      vendorMessageLastUpdateUser: null,
      productAssets: {
        productId: '3001',
        lastUpdated: '2024-03-20T00:00:00Z',
        documents: null,
        videos: null,
        sellerVideos: null,
        productImages: null,
      },
      justInTime: false,
      directEligible: false,
      substituteProducts: [],
    } as any,
    contract: {
      productNumber: 3001,
      client: 'MED',
      clientConcept: 'PREMIER',
      startDate: '2024-01-01',
      endDate: '2024-12-31',
      contractNumber: 123,
      groupNumber: 432,
      iconId: 423,
      iconFile: 'file.txt',
      iconText: 'XMR',
      iconDescription: 'GOOD CONTRACT',
    },
    inventory: {
      divisionNumber: 2099,
      productNumber: 3001,
      casesOnHand: 20,
      casesOnReserve: 12,
      casesWaitlistReserve: 1,
      casesToEachDemand: 2,
      eachOnHand: 15,
      eachOnReserve: 10,
      eachWaitListReserve: 2,
      eachConversionFactor: 1,
      cashCarryIndicator: '0',
      justInTime: false,
      substituteProducts: [],
      directEligible: false,
      productStatus: '0',
      purchaseFromVendor: 547,
      vendorActiveInd: null,
      vendorEffectiveDate: null,
      vendorLeadTime: null,
      vendorMessage: '',
      vendorMessageLastUpdateDTM: null,
      vendorMessageLastUpdateUser: null,
      isInStock: true,
      available: true,
    },
    notFound: false,
    orderable: true,
    hideOutOfStock: false,
    hotkeyIds: [],
    productTags: [],
    hasAlternative: false,
    hideQuantityBoxes: false,
    trackingAttributes: '',
    imageThumbnail:
      'https://assets-qa.usfoods.com/Product/Image/9825772/1aaa3498fb796679a8a3fe4715f4929e.jpg',
    showInfoIcon: false,
    vendorMsg: '',
    isMslRestricted: false,
    customerProductNumber: '',
    isGLCustomer: false,
    allowSearchForSubs: false,
    showWorksWellWith: false,
    promotionDetails: {
      productNumber: 3001,
      promoId: 'TDM475',
      offerId: 'TDM475',
      invoiceText: 'Test Invoice message',
      promoSource: 'TDM',
      promoSourceDesc: 'Tandem',
      offerType: 'INV',
      offerTypeDesc: 'Invoice',
      offerPriority: '1',
      offerAllowanceCode: '475',
      offerAllowanceCodeDesc: 'Tandem Allowance Code',
      offerStartDate: '2024-01-01T00:00:00.000Z',
      offerEndDate: '2024-12-31T23:59:59.000Z',
      offerAmount: '2',
      offerAmountType: 'DL',
      offerApplyPer: 'CS',
      offerApplyEach: 'N',
      offerIcon: 'Promotion-16.png',
      offerBenefitDesc: 'Save 2% OFF / CS',
      offerValidFromDesc:
        'Valid on items purchased from Jan 1 2024 - Dec 31 2024',
      offerApplyEachDesc: 'Applies to full case orders only.',
      offerQualification: 'Test qualification Details',
      offerLegalDisclaimer: 'Test Legal Disclaimer',
    },
  };

  // REMOVE ME - IM JUST MOCK DATA
  invDates = ['2024-01-01', '2024-02-01', '2024-03-01', '2024-03-01'];

  // REMOVE ME - IM JUST MOCK DATA
  invoices = ['00000', '00000', '00000', '00000'];

  // REMOVE ME - IM JUST MOCK DATA
  wwp = ['00000', '00000', '00000', '00000'];

  // REMOVE ME - IM JUST MOCK DATA
  prices = ['1000', '1000', '1000', '1000'];

  // REMOVE ME - IM JUST MOCK DATA
  targetPercents = ['1', '2', '3', '4'];

  // REMOVE ME - IM JUST MOCK DATA
  quantities = ['1', '1', '1', '1'];

  // REMOVE ME - IM JUST MOCK DATA
  MTD = ['cpr', 'cpr', 'cpr', 'cpr'];

  // REMOVE ME - IM JUST MOCK DATA
  dept = ['', '', '', ''];

  // REMOVE ME - IM JUST MOCK DATA
  GPD = ['5.1', '5.26', '8', '2'];

  // REMOVE ME - IM JUST MOCK DATA
  GPP = ['4', '4', '6', '4'];

  // REMOVE ME - IM JUST MOCK DATA
  gpd = '$5.00';
  gpp = '4%';
  marketChange = '$5';
  breakSurcharge = '$33.34';
  asc = '$5.00s, $5.00p';
  eachPrice = '$5.00';

  // REMOVE ME - IM JUST MOCK DATA
  approvedCPR = '$111.15';
  approvedCPREnd = '05/01/2025';
  requestedCPR = '$111.15';
  requestedCPRDate = '05/01/2025';

  // REMOVE ME - IM JUST MOCK DATA
  driverInfo = 'John Doe';
  driverNumber = '1234567890';

  // Mock data for price mode sidebar
  lastWeek = '$125.00';
  lowLimit = '$100.00';
  wwp2 = '$115.00';
  rationale = 'Market adjustment based on competitor pricing';
  targetDifference = '$10.00';

  // REMOVE ME - IM JUST MOCK DATA
  customPrice = '125.00';
  targetCasePrice = '$150.00';

  // REMOVE ME - IM JUST MOCK DATA
  somePrice = '$125.00';

  // REMOVE ME - IM JUST MOCK DATA
  currentWeekPriceChange = '-10.00';

  constructor() {}

  setPriceTarget() {
    this.targetCasePriceSet = true;
  }

  getAlternativeThumbnail(imageUrl: string): string {
    // Return a default image URL when the main image fails to load
    return 'assets/images/default-product-image.png';
  }
}
